const genderMap = {
  male: '先生',
  female: '小姐',
};

const petGenderMap = {
  male: '公',
  female: '母',
};

const userGenderMap = {
  male: '男性',
  female: '女性',
};

export default function formatGender(gender) {
  return genderMap[gender] || ''
}

export function formatPetGender(gender) {
  return process.env.VUE_APP_MODE === 'dingbeauty' ? userGenderMap[gender] || '' : petGenderMap[gender] || ''
}
